export class Controller {

    /** @ngInject */
    constructor($window, GoogleSharedService) {
        this.$window = $window;
        this.GoogleSharedService = GoogleSharedService;
    }

    $onInit() {
        const expires = new Date(Date.now() + 60 * 1000).toUTCString();
        document.cookie = `gmarketDomainEndUser=${this.domain}; path=/; expires=${expires}`;
        this.GoogleSharedService.getGoogleEndUserAuthUrl.get().$promise
            .then(data => this.$window.location = data.requestUrl);
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/public/google-marketplace-login/google-marketplace-login.controller.js